var map = {
	"./ANDALUSIA.jpg": "fc82",
	"./BAVARIA.jpg": "369b",
	"./CENTRAL_GERMANY.jpg": "7945",
	"./FLANDERS.jpg": "0018",
	"./ITALY.jpg": "dc8e",
	"./LVIV.jpg": "12f1",
	"./MAZOVIA.jpg": "6b97",
	"./NITRA.jpg": "f39d",
	"./SOUTHERN_GREAT_PLAIN.jpg": "baa4",
	"./SOUTH_BOHEMIA.jpg": "184c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a17f";